import { TranslationsContext } from '@teliaee/telia-translate';
import { Card, CardContent, GridColumn, Heading, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import React from 'react';
import RoamingStore from '../../stores/RoamingStore';
import PackageOrderingModal from './PackageOrderingModal';

interface MonthPackageProps {
  roamingStore?: RoamingStore;
}

const MonthPackage = (props: MonthPackageProps): React.JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const { roamingStore } = props;
  const monthPackage = roamingStore.getPackageByShortName('GMOON');

  if (!monthPackage) {
    return null;
  }
  return (
    <GridColumn width={['md-12', 'lg-4']}>
      <Card background="neutral-bg-level-3">
        <CardContent>
          <Text className="text-left">
            <Heading element="h4" className="h3">
              {translate(`roaming.country.package.name.${monthPackage.serviceShortName}`)}
            </Heading>
            <p>{translate('roaming.country.package.volume')}</p>
            <p className="text__margin-none h2">{translate(`roaming.country.package.volume.${monthPackage.volume}`)}</p>
            <p className="text__margin-double">{translate('roaming.country.package.price')}</p>
            <p className="text__margin-none text-bold h4">
              {roamingStore.getPackagePrice(monthPackage)} {translate('roaming.package.price.currency')}
            </p>
            <PackageOrderingModal roamingPackage={monthPackage} />
          </Text>
        </CardContent>
      </Card>
    </GridColumn>
  );
};

export default inject('roamingStore')(observer(MonthPackage));
